import { ErrorSa, VerificationGetRequest, VerificationGetResponse } from "../models";
import { ApplicationState } from "./ApplicationRedux";
import { useSelector, useDispatch } from "react-redux";
import { useVerificationsProxy } from "../proxies";
import { FormatName } from "../utils/stringHelper";


export const VerificationsActionTypes = {
	GET_VERIFICATION_LOAD_START: "GET_VERIFICATION_LOAD_START",
	GET_VERIFICATION_LOAD_SUCCESS: "GET_VERIFICATION_LOAD_SUCCESS",
	GET_VERIFICATION_LOAD_FAILURE: "GET_VERIFICATION_LOAD_FAILURE",
	VERIFICATION_START_OVER: "VERIFICATION_START_OVER",
};

export interface IVerificationsRedux {
	state: VerificationsState;
	loadVerification: Function;	
	verificationStartOver: Function;
}

export const useVerificationsRedux = () => {
	const state = useSelector((state: ApplicationState) => state.verifications);
	const dispatch = useDispatch();

	const _verificationsProxy = useVerificationsProxy();

	const loadVerification = (request: VerificationGetRequest) => {
		dispatch({ type: VerificationsActionTypes.GET_VERIFICATION_LOAD_START, data: FormatName(request.firstName, request.lastName, request.middleInitial) });
		_verificationsProxy.get(request).subscribe(
			(response: VerificationGetResponse) => {
				if (response) {
					dispatch({ type: VerificationsActionTypes.GET_VERIFICATION_LOAD_SUCCESS, data: response });
				} else {
					dispatch({ type: VerificationsActionTypes.GET_VERIFICATION_LOAD_FAILURE, error: { message: "Error getting verification" } });
				}
			},
			(error: any) => {
				dispatch({ type: VerificationsActionTypes.GET_VERIFICATION_LOAD_FAILURE, error });
			}
		);
	};

	const verificationStartOver = () => {
		dispatch({type: VerificationsActionTypes.VERIFICATION_START_OVER, data: null});
	}

	const result: IVerificationsRedux = { state, loadVerification, verificationStartOver};

	return result;
};

export type VerificationsState = {
	working: boolean;
	error: ErrorSa | null;
	verification: VerificationGetResponse | null;
	searchName: string;
};

type VerificationsAction = {
	type: string;
	data : any
	error: ErrorSa | null | undefined;
};

const initialState: VerificationsState = {
	searchName: '',
	working: false,
	error: null,
	verification: null,
};

export const VerificationsReducer = (state: VerificationsState, action: VerificationsAction) => {
	state = state || initialState;

	if (action.type === VerificationsActionTypes.GET_VERIFICATION_LOAD_START) {
		return { ...state, searchName: action.data, working: true };
	}

	if (action.type === VerificationsActionTypes.GET_VERIFICATION_LOAD_FAILURE) {
		const { error } = action;
		return { ...state, working: false, error: error };
	}

	if (action.type === VerificationsActionTypes.GET_VERIFICATION_LOAD_SUCCESS) {
		return { ...state, working: false, error: null, verification: action.data };
	}

	if(action.type === VerificationsActionTypes.VERIFICATION_START_OVER) {
		return {...state, working:false, error: null, verification: null}
	}

	return state;
};
